import AppUserProfile, { UserType } from "./AppUserProfile";

export const TicketPhase = Object.freeze({
  Proposal: { value: "PROPOSAL" },
  Claim: { value: "CLAIM" },
  Management: { value: "MANAGEMENT" },
  Accounting: { value: "ACCOUNTING" },
});

export const stringToTicketPhase = (phaseString) => {
  const phase = Object.entries(TicketPhase).find(
    ([, value]) => value.value === phaseString.toUpperCase()
  );

  return phase ? TicketPhase[phase[0]] : null;
};

export const TicketStatus = Object.freeze({
  Cancelled: { value: "CANCELLED" },
  AwaitingApproval: { value: "AWAITING_APPROVAL" },
  AwaitingOther: { value: "AWAITING_OTHER" },
  Approved: { value: "APPROVED" },
  Rejected: { value: "REJECTED" },
  Paid: { value: "PAID" },
  Edit: { value: "EDIT" },
});

export const stringToTicketStatus = (statusString) => {
  const status = Object.entries(TicketStatus).find(
    ([, value]) => value.value === statusString.toUpperCase()
  );

  return status ? TicketStatus[status[0]] : null;
};

export const CommonTicketPhase = [
  {
    id: TicketPhase.Proposal,
    name: "คำขอจัดกิจกรรม",
    value: [TicketPhase.Proposal],
  },
  {
    id: TicketPhase.Claim,
    name: "คำขอเบิกจ่าย",
    value: [TicketPhase.Claim, TicketPhase.Management],
  },
  {
    id: TicketPhase.Accounting,
    name: "คำขอรอตรวจสอบงบ",
    value: [TicketPhase.Accounting],
  },
];

export const CommonTicketStatus = [
  { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติ" },
  { id: TicketStatus.AwaitingOther, name: "รอการอนุมัติจากคนอื่น" },
  { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติ" },
  { id: TicketStatus.Approved, name: "อนุมัติแล้ว" },
];

const approverClaimTicketStatus = [
  {
    id: TicketStatus.All,
    name: "ทั้งหมด",
  },
  { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติจากคุณ" },
  { id: TicketStatus.AwaitingOther, name: "รอการอนุมัติจากคนอื่น" },
  { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติ" },
  { id: TicketStatus.Approved, name: "อนุมัติคำของบผ่านการตรวจสอบแล้ว" },
  { id: TicketStatus.Cancelled, name: "คำขอทำจ่ายถูกยกเลิก" },
];

const delaerClaimTicketStatus = [
  {
    id: TicketStatus.All,
    name: "ทั้งหมด",
  },
  { id: TicketStatus.AwaitingApproval, name: "รออนุมัติ" },
  { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติ" },
  { id: TicketStatus.Approved, name: "อนุมัติคำของบผ่านการตรวจสอบแล้ว" },
  { id: TicketStatus.Cancelled, name: "คำขอทำจ่ายถูกยกเลิก" },
];

export const DealerTicketStatusConfig = {
  PROPOSAL: [
    {
      id: TicketStatus.All,
      name: "ทั้งหมด",
    },
    { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติ" },
    { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติ" },
    { id: TicketStatus.Approved, name: "อนุมัติคำขอแล้ว" },
    { id: TicketStatus.Cancelled, name: "คำขอถูกยกเลิก" },
  ],
  MANAGEMENT: delaerClaimTicketStatus,
  CLAIM: delaerClaimTicketStatus,
  ACCOUNTING: [
    {
      id: TicketStatus.All,
      name: "ทั้งหมด",
    },
    {
      id: TicketStatus.AwaitingApproval,
      name: "รออนุมัติการทำจ่าย",
    },
    {
      id: TicketStatus.Approved,
      name: "งบผ่านการตรวจสอบแล้ว",
    },
    {
      id: TicketStatus.Rejected,
      name: "ไม่อนุมัติทำจ่าย",
    },
    { id: TicketStatus.Cancelled, name: "คำขอถูกยกเลิก" },
  ],
};

export const ApproverTicketStatusConfig = {
  PROPOSAL: [
    {
      id: TicketStatus.All,
      name: "ทั้งหมด",
    },
    { id: TicketStatus.AwaitingApproval, name: "รอการอนุมัติจากคุณ" },
    { id: TicketStatus.AwaitingOther, name: "รอการอนุมัติจากคนอื่น" },
    { id: TicketStatus.Rejected, name: "ไม่ได้รับการอนุมัติ" },
    { id: TicketStatus.Approved, name: "อนุมัติคำขอแล้ว" },
    { id: TicketStatus.Cancelled, name: "คำขอถูกยกเลิก" },
  ],
  MANAGEMENT: approverClaimTicketStatus,
  CLAIM: approverClaimTicketStatus,
  ACCOUNTING: [
    {
      id: TicketStatus.All,
      name: "ทั้งหมด",
    },
    {
      id: TicketStatus.AwaitingApproval,
      name: "รออนุมัติการทำจ่าย",
    },
    {
      id: TicketStatus.AwaitingOther,
      name: "รออนุมัติการทำจ่ายจากคนอื่น",
    },
    {
      id: TicketStatus.Approved,
      name: "งบผ่านการตรวจสอบแล้ว",
    },
    {
      id: TicketStatus.Rejected,
      name: "ไม่อนุมัติทำจ่าย",
    },
    { id: TicketStatus.Cancelled, name: "คำขอถูกยกเลิก" },
  ],
};

export const getStatusDisplayName = ({ phase, status, approveSequence }) => {
  const userRole = AppUserProfile.getData()["whoami"];

  const statusConfig =
    userRole == UserType.REVER || userRole == UserType.ACCOUNTANT
      ? ApproverFilterTicketConfig.statuses[phase]
      : DealerFilterTicketConfig.statuses[phase];

  if (!statusConfig) {
    return null;
  }

  return statusConfig.find((option) => {
    return option.id === matchConfig({ approveSequence, status }).value;
  });
};

const matchConfig = ({ approveSequence, status }) => {
  const userRole = AppUserProfile.getData()["whoami"];
  const userRoleName = AppUserProfile.getData()["role_name"];
  const userId = Number(AppUserProfile.getData()["user_id"]);
  if (userRole == UserType.REVER || userRole == UserType.ACCOUNTANT) {
    switch (stringToTicketStatus(status)) {
      case TicketStatus.AwaitingApproval:
        return approveSequence.next_approver_user_id === userId &&
          approveSequence.next_approver_level === userRoleName
          ? TicketStatus.AwaitingApproval
          : TicketStatus.AwaitingOther;
      default:
        return stringToTicketStatus(status);
    }
  }
  return stringToTicketStatus(status);
};

export const DealerFilterTicketConfig = {
  phaseGroups: [
    {
      id: "PROPOSAL",
      name: "คำขอจัดกิจกรรม",
      phases: [TicketPhase.Proposal.value],
    },
    {
      id: "PAYMENT",
      name: "คำขอเบิกจ่าย",
      phases: [TicketPhase.Claim.value, TicketPhase.Management.value],
    },
    {
      id: "ACCOUNTING",
      name: "ทำจ่าย",
      phases: [TicketPhase.Accounting.value],
    },
  ],
  statuses: {
    PROPOSAL: [
      {
        id: "APPROVED",
        name: "อนุมัติแล้ว",
      },
      {
        id: "REJECTED",
        name: "ไม่ได้รับอนุมัติ",
      },
      {
        id: "AWAITING_APPROVAL",
        name: "รออนุมัติ",
      },
      {
        id: "CANCELLED",
        name: "ยกเลิก",
      },
    ],
    CLAIM: [
      {
        id: "APPROVED",
        name: "อนุมัติแล้ว",
      },
      {
        id: "REJECTED",
        name: "ไม่ได้รับอนุมัติ",
      },
      {
        id: "AWAITING_APPROVAL",
        name: "รออนุมัติ",
      },
      {
        id: "CANCELLED",
        name: "ยกเลิก",
      },
    ],
    MANAGEMENT: [
      {
        id: "APPROVED",
        name: "อนุมัติแล้ว",
      },
      {
        id: "REJECTED",
        name: "ไม่ได้รับอนุมัติ",
      },
      {
        id: "AWAITING_APPROVAL",
        name: "รออนุมัติ",
      },
      {
        id: "CANCELLED",
        name: "ยกเลิก",
      },
    ],
    ACCOUNTING: [
      {
        id: "APPROVED",
        name: "งบผ่านการตรวจสอบแล้ว",
      },
      {
        id: "REJECTED",
        name: "ไม่ได้รับอนุมัติทำจ่าย",
      },
      {
        id: "AWAITING_APPROVAL",
        name: "รอตรวจสอบงบประมาณ",
      },
      {
        id: "CANCELLED",
        name: "ยกเลิก",
      },
    ],
  },

  allStatuses: [
    {
      id: "APPROVED",
      name: "อนุมัติแล้ว",
      phase: [
        TicketPhase.Proposal.value,
        TicketPhase.Claim.value,
        TicketPhase.Management.value,
      ],
    },
    {
      id: "APPROVED",
      name: "งบผ่านการตรวจสอบแล้ว",
      phase: [TicketPhase.Accounting.value],
    },
    {
      id: "REJECTED",
      name: "ไม่ได้รับอนุมัติ",
      phase: [
        TicketPhase.Proposal.value,
        TicketPhase.Claim.value,
        TicketPhase.Management.value,
      ],
    },
    {
      id: "REJECTED",
      name: "ไม่ได้รับอนุมัติทำจ่าย",
      phase: [TicketPhase.Accounting.value],
    },
    {
      id: "AWAITING_APPROVAL",
      name: "รออนุมัติ",
      phase: [
        TicketPhase.Proposal.value,
        TicketPhase.Claim.value,
        TicketPhase.Management.value,
      ],
    },
    {
      id: "AWAITING_APPROVAL",
      name: "รอตรวจสอบงบประมาณ",
      phase: [TicketPhase.Accounting.value],
    },
    {
      id: "CANCELLED",
      name: "ยกเลิก",
      phase: [
        TicketPhase.Proposal.value,
        TicketPhase.Claim.value,
        TicketPhase.Management.value,
        TicketPhase.Accounting.value,
      ],
    },
  ],
};

export const ApproverFilterTicketConfig = {
  phaseGroups: [
    {
      id: "PROPOSAL",
      name: "คำขอจัดกิจกรรม",
      phases: [TicketPhase.Proposal.value],
    },
    {
      id: "PAYMENT",
      name: "คำขอเบิกจ่าย",
      phases: [TicketPhase.Claim.value, TicketPhase.Management.value],
    },
    {
      id: "ACCOUNTING",
      name: "ทำจ่าย",
      phases: [TicketPhase.Accounting.value],
    },
  ],
  statuses: {
    PROPOSAL: [
      { id: "APPROVED", name: "อนุมัติแล้ว" },
      { id: "REJECTED", name: "ไม่ได้รับอนุมัติ" },
      {
        id: "AWAITING_APPROVAL",
        name: "รออนุมัติจากคุณ",
      },
      {
        id: "AWAITING_OTHER",
        name: "รออนุมัติจากคนอื่น",
      },
      {
        id: "CANCELLED",
        name: "ยกเลิก",
      },
    ],
    CLAIM: [
      { id: "APPROVED", name: "อนุมัติแล้ว" },
      { id: "REJECTED", name: "ไม่ได้รับอนุมัติ" },
      {
        id: "AWAITING_APPROVAL",
        name: "รออนุมัติจากคุณ",
      },
      {
        id: "AWAITING_OTHER",
        name: "รออนุมัติจากคนอื่น",
      },
      {
        id: "CANCELLED",
        name: "ยกเลิก",
      },
    ],
    MANAGEMENT: [
      { id: "APPROVED", name: "อนุมัติแล้ว" },
      { id: "REJECTED", name: "ไม่ได้รับอนุมัติ" },
      {
        id: "AWAITING_APPROVAL",
        name: "รออนุมัติจากคุณ",
      },
      {
        id: "AWAITING_OTHER",
        name: "รออนุมัติจากคนอื่น",
      },
      {
        id: "CANCELLED",
        name: "ยกเลิก",
      },
    ],
    ACCOUNTING: [
      {
        id: "APPROVED",
        name: "งบผ่านการตรวจสอบแล้ว",
      },
      {
        id: "REJECTED",
        name: "ไม่ได้รับอนุมัติทำจ่าย",
      },
      {
        id: "AWAITING_APPROVAL",
        name: "รอตรวจสอบงบประมาณจากคุณ",
      },
      {
        id: "AWAITING_OTHER",
        name: "รอตรวจสอบงบประมาณจากคนอื่น",
      },
      {
        id: "CANCELLED",
        name: "ยกเลิก",
      },
    ],
  },

  allStatuses: [
    {
      id: "APPROVED",
      name: "อนุมัติแล้ว",
      phase: [
        TicketPhase.Proposal.value,
        TicketPhase.Claim.value,
        TicketPhase.Management.value,
      ],
    },
    {
      id: "APPROVED",
      name: "งบผ่านการตรวจสอบแล้ว",
      phase: [TicketPhase.Accounting.value],
    },
    {
      id: "REJECTED",
      name: "ไม่ได้รับอนุมัติ",
      phase: [
        TicketPhase.Proposal.value,
        TicketPhase.Claim.value,
        TicketPhase.Management.value,
      ],
    },
    {
      id: "REJECTED",
      name: "ไม่ได้รับอนุมัติทำจ่าย",
      phase: [TicketPhase.Accounting.value],
    },
    {
      id: "AWAITING_APPROVAL",
      name: "รออนุมัติจากคุณ",
      phase: [
        TicketPhase.Proposal.value,
        TicketPhase.Claim.value,
        TicketPhase.Management.value,
      ],
    },
    {
      id: "AWAITING_APPROVAL",
      name: "รอตรวจสอบงบประมาณจากคุณ",
      phase: [TicketPhase.Accounting.value],
    },
    {
      id: "AWAITING_OTHER",
      name: "รออนุมัติจากคนอื่น",
      phase: [
        TicketPhase.Proposal.value,
        TicketPhase.Claim.value,
        TicketPhase.Management.value,
      ],
    },
    {
      id: "AWAITING_OTHER",
      name: "รอตรวจสอบงบประมาณจากคนอื่น",
      phase: [TicketPhase.Accounting.value],
    },
    {
      id: "CANCELLED",
      name: "ยกเลิก",
      phase: [
        TicketPhase.Proposal.value,
        TicketPhase.Claim.value,
        TicketPhase.Management.value,
        TicketPhase.Accounting.value,
      ],
    },
  ],
};
